import * as leadformConstants from '../constants';
import '../../../principles/polyfills/closest';

// Gets the Leadform associated with an element
export default function getLeadform(element) {
  return element.closest(leadformConstants.leadformClasses.leadform);
}
